import React, { useState, useEffect, useContext, useRef } from 'react';
import {ResourceList as ResourceListShopify, Avatar, TextStyle, Stack, Link, TopBar, Icon} from '@shopify/polaris';
import {EditMinor} from '@shopify/polaris-icons';
import {SearchContext} from '@thinkwell/react.common';
import {ResourceList} from '@thinkwell/react.polaris';
import EditCourse from './EditCourse';
import MainFrame from '../MainFrame';
import { CoursesContext } from '../contexts/Courses'
import compact from 'lodash/compact';
import debounce from 'lodash/debounce';
import sortBy from 'lodash/sortBy'

const formatDate = (dateStr) => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(dateStr))
};

export default function Courses(props) {
  const [courses, fetchCourses, fetchCoursesState] = useContext(CoursesContext);
  const [search, setSearch] = useContext(SearchContext);

  const navigateToRef = useRef()
  const [addCourseActive, setAddCourseActive] = useState(false);
  const [editCourseItem, setEditCourseItem] = useState()
  const [isCourseMenuOpen, setIsCourseMenuOpen] = useState(false);
  const toggleIsCourseMenuOpen = () => setIsCourseMenuOpen((isCourseMenuOpen) => !isCourseMenuOpen);

  const coursesSorted = sortBy(courses, ['name']);

  const onSearch = (params) => {
    fetchCourses(`/courses.json`, params)
  }

  const delayedSearch = useRef(debounce(onSearch, 1000));

  const onSearchChange = (value) => {
    setSearch(value)
    delayedSearch.current({query: value})
  }

  const courseMenuMarkup = (
     <TopBar.UserMenu
       actions={[
         {
           items: [
             {content: 'Add Course', onAction: () => { setEditCourseItem(null); setAddCourseActive(true) }},
             {content: 'Logout', url: '/logout'}
           ]
         }
       ]}
       name="Courses"
       initials="C"
       open={isCourseMenuOpen}
       onToggle={toggleIsCourseMenuOpen}
     />
   );

  const renderCourse = (item) => {
    const {name} = item;
    return (
      <ResourceListShopify.Item
        id={item.id}
        accessibilityLabel={`View details for ${name}`}
        onClick={() => navigateToRef.current(`courses/${item.id}`, {withContext: true})}
        shortcutActions={[{content: <Icon source={EditMinor} />, onAction: () => { setEditCourseItem(item); setAddCourseActive(true) }}]}
      >
        <Stack>
          <Stack.Item fill>
            <h3>
              <TextStyle variation="strong">{name}</TextStyle>
            </h3>
          </Stack.Item>
          <Stack.Item>
            <TextStyle variation="subdued">{item.product.name}</TextStyle>
          </Stack.Item>
        </Stack>
      </ResourceListShopify.Item>
    );
  };

  const onAddCourse = (course) => {
    if (!editCourseItem) {
      navigateToRef.current(`courses/${course.id}`)
    }
  }

  return (
    <div>
    <MainFrame onSearchChange={onSearchChange} searchPlaceHolder="Search courses"
    userMenu={courseMenuMarkup} navigateToRef={navigateToRef}>
      { addCourseActive ?
        <EditCourse
          item={editCourseItem}
          active={addCourseActive}
          onActive={(active) => { if (active != addCourseActive) { setAddCourseActive(active) }}}
          onSave={onAddCourse}
        /> :
        <ResourceList withoutSort items={coursesSorted} fetchItems={fetchCourses} fetchItemsState={fetchCoursesState}
        url="/courses.json" renderItem={renderCourse}
        resourceName={ {singular: 'course', plural: 'courses'} }></ResourceList>
      }
    </MainFrame>
  </div>);
}
